import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { getBrands } from "@/api/corrugates-api";
import type { CorrugateBrand } from "@/schemas";

export const BRANDS_QUERY_KEY = ["brands"] as const;

type UseBrandsQueryOptions = Omit<
	UseQueryOptions<CorrugateBrand[], Error, CorrugateBrand[], typeof BRANDS_QUERY_KEY>,
	"queryKey" | "queryFn"
>;

export const useBrands = (queryConfig: UseBrandsQueryOptions = {}) => {
	const query = useQuery({
		queryKey: BRANDS_QUERY_KEY,
		queryFn: getBrands,
		...queryConfig,
	});

	return {
		brands: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error,
		refetch: query.refetch,
	};
};
